var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AsyncStateNotification } from '@ui/notifications';
import { createAsyncSelectors } from '@lib/selectors';
import React from 'react';
import { Button } from 'antd';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { useAction, useCurrentUser, useFeatureFlag } from '@hooks';
export const exportStartSelectors = createAsyncSelectors((state) => state.core.dataDictionary.export.post);
export const DataDictionaryExportButton = (_a) => {
    var { applicationId, complianceCategory, filters, sonarObjectId, sonarObjectType, tagId } = _a, rest = __rest(_a, ["applicationId", "complianceCategory", "filters", "sonarObjectId", "sonarObjectType", "tagId"]);
    const startExport = useAction(coreActions.requestPostCoreDataDictionaryExport);
    const { isReadOnly } = useCurrentUser();
    const isExportEnabled = useFeatureFlag(FeatureFlag.Export);
    if (isReadOnly) {
        return null;
    }
    const hasId = sonarObjectId ||
        sonarObjectType ||
        applicationId ||
        tagId ||
        typeof complianceCategory === 'number';
    return (React.createElement("div", { className: 'data-dictionary-export' },
        React.createElement(Button, Object.assign({ disabled: !isExportEnabled || !hasId, id: 'data-dictionary-export-button', onClick: () => startExport({
                applicationId,
                complianceCategory,
                filters,
                sonarObjectId,
                sonarObjectType,
                sortBy: 'name',
                sortDirection: 'Ascending',
                tagId
            }), size: 'large', type: 'primary' }, rest), COPY_SPECIFIC.EXPORT),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_POST_DATA_DICTIONARY_EXPORT, failed: {
                description: NOTIFICATIONS_COPY.FAILED_POST_DATA_DICTIONARY_EXPORT,
                options: { message: NOTIFICATIONS_COPY.FAILED_POST_DATA_DICTIONARY_EXPORT_MESSAGE }
            }, received: {
                description: NOTIFICATIONS_COPY.SUCCESS_POST_DATA_DICTIONARY_EXPORT,
                options: { message: NOTIFICATIONS_COPY.SUCCESS_POST_DATA_DICTIONARY_EXPORT_MESSAGE }
            }, resetRawAction: coreActions.resetPostCoreDataDictionaryExport, stateSelector: exportStartSelectors.state })));
};
